import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import { userDetail } from "../../../config/userDetails";
import { commodityList, getCommodityVariertyList, getContractStage, getContractType, getDestinationByType, getSelectedContractDetail, InternalDestinationList } from "../../../modules/contract/action";
import { createNewTicket, FillingForm, getCounterpartList, getLoadNumberIndicatorList, getOriginType } from "../../../modules/ticket/action";
import { trucklineListAction } from "../../../modules/truckline/action";
import "../../../style";
import { getFullDateTime } from "../../../utils/DateFormatter";
import TicketForm from "./TicketForm";






const defaultDestinationTypeId = "2";

class CreateTicket extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ticketInfo: {
        farmId: this.props.SubFarmId
          ? this.props.SubFarmId
          : userFarmDetail().id,
        primaryContractNumber: "",
        ticketNumber: "",
        counterpartId: "",
        type: "",
        originTypeId: "",
        loadDate: new Date(),
        commodityId: "",
        commodityVarietyId: "",
        destinationTypeId: defaultDestinationTypeId,
        destinationId: "",
        trucklineId: "",
        truckNumber: "",
        trailerNumber: "",
        driverName: "",
        loadNumberIndicatorId: "",
        loadNumber: "",
        scaleTicketNumber: "",
        billOfLading: "",
        fieldEstimatedLoadWeight: "",
        fieldEstimatedLoadBushels: 0,
        fieldsEstimatedMoisture: "",
        shrinkMultiplier: "",
        estimatedHomeScaleShrinkBushels: 0,
        homeScaleEstimatedMoisture: "",
        homeScaleWeightFilled: "",
        homeScaleWeightEmpty: "",
        primarySourceId: "",
        secondarySourceId: "",
        loadCost: 0
      },
      successMessage: "",
      isValid: true,
      mandatoryFields: {
        1: [
          "loadDate",
          "commodityId",
          "commodityVarietyId",
          "originTypeId",
          "primarySourceId",
          "destinationId",
          "loadNumberIndicatorId"
          // "truckNumber",
          // "driverName"
        ],
        2: [
          "counterpartId",
          "commodityId",
          "loadDate",
          "commodityVarietyId",
          "originTypeId",
          "primarySourceId",
          "destinationId",
          "loadNumberIndicatorId",
          "trucklineId"
        ]
      }
    };
  }
  componentWillMount() {
    const timestamp = Date.now();
    this.props.actions.FillingForm();
    let userId,
      id = "";
    const { SubFarmId, FarmsList } = this.props;
    if (
      SubFarmId === userFarmDetail().id ||
      SubFarmId === this.props.MainFarmId
    ) {
      id =
        userFarmDetail().farmId ||
        this.props.MainFarmsList.filter(item => item.id === SubFarmId)[0]
          .farmId;
    } else {
      console.log();
      id = SubFarmId
        ? FarmsList.filter(item => item.id === SubFarmId)[0].farmId
        : userFarmDetail().farmId;
    }
    userId = userDetail().userId;
    let loadtime = getFullDateTime(this.state.ticketInfo.loadDate);

    this.setState(prevState => {
      return {
        ticketInfo: {
          ...prevState.ticketInfo,
          ["ticketNumber"]: `${id}-${userId}-${loadtime}`
        }
      };
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.ticketCreated && nextProps.ticketCreated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  createTicket = ticketInfo => {
    // const { ticketInfo } = this.state;
    this.setState({
      isValid: true
    });
    this.props.actions.createNewTicket(ticketInfo);
  };

  checkValidation = ticketInfo => {
    const { mandatoryFields } = this.state;
    const { destinationTypeId } = ticketInfo;
    if (mandatoryFields[1].length === 7 && ticketInfo.trucklineId) {
      mandatoryFields[1].push("driverName");
    } else if (
      mandatoryFields[1].length === 9 &&
      ticketInfo.trucklineId === ""
    ) {
      mandatoryFields[1].pop();
    }

    if (mandatoryFields[2].length === 9 && ticketInfo.trucklineId) {
      mandatoryFields[2].push("driverName");
    } else if (
      mandatoryFields[2].length === 11 &&
      ticketInfo.trucklineId === ""
    ) {
      mandatoryFields[2].pop();
    }

    const mandatoryFieldsArray = mandatoryFields[destinationTypeId];

    let checkValididtyi = mandatoryFieldsArray.filter(
      value => ticketInfo[value] === ""
    );

    this.setState({
      isValid: checkValididtyi.length > 0
    });
    // const isValid =  mandatoryFieldsArray.reduce((accumulator, currentValue)=>{
    //     if(ticketInfo[currentValue]){
    //         console.log(ticketInfo[currentValue] , 'if' , accumulator && false)
    //         return accumulator && false;
    //     }else{
    //         console.log(ticketInfo[currentValue] , 'elseif' , accumulator || true)
    //         return accumulator || true;
    //     }
    // }, true);
    // console.log(isValid);
    // this.setState({
    //     isValid,
    // })
  };

  render() {
    const { ticketInfo, successMessage, isValid } = this.state;
    if (successMessage) {
      return <Redirect to="/app/tickets" />;
    }

    return (
      <TicketForm
        formLabel="New Ticket"
        buttonLabel="Save Ticket"
        ticketInfo={ticketInfo}
        changeFunction={this.handleChange}
        submitFunction={this.createTicket}
        checkValidation={this.checkValidation}
        isValid={isValid}
      />
    );
  }
}
function mapStateToProps(state) {
  return {
    ticketCreated: state.ticketReducer.ticketCreated,
    commodityList: state.contractReducer.commodityList,
    commodityVarietyList: state.contractReducer.commodityVarietyList,
    LoadNumberIndicatorList: state.ticketReducer.LoadNumberIndicatorList,
    selectedContractDetails: state.contractReducer.selectedContractDetails,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    MainFarmsList: state.FarmManagementReducer.MainFarmsList,
    FarmsList: state.FarmManagementReducer.FarmsList
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        commodityList,
        getCommodityVariertyList,
        getCounterpartList,
        getContractStage,
        getContractType,
        getOriginType,
        getDestinationByType,
        getLoadNumberIndicatorList,
        createNewTicket,
        InternalDestinationList,
        trucklineListAction,
        getSelectedContractDetail,
        FillingForm
      },
      dispatch
    )
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateTicket);



// WEBPACK FOOTER //
// ./src/components/private/Tickets/CreateTicket.js